export { default as DeliveryAssetsListPage } from "./delivery-assets"
export { default as DeliveryAssetsFormPage } from "./delivery-assets-form"